export default function() {
    var items_array = []
    $('.categories-caroussels').find('.caroussel-category').each(function(index, value) {
        items_array.push($(this).attr("id"));
    });
    $.each(items_array, function(index, value) {
        $('#' + value).children(".carousel").find(".caroussel-list:first").addClass("active");
        $('#' + value).children(".carousel").find(".sample-video:first").addClass("active");
    })
}